import { render, staticRenderFns } from "./CargoCompanySettings.vue?vue&type=template&id=2bd5c350"
import script from "./CargoCompanySettings.vue?vue&type=script&lang=js"
export * from "./CargoCompanySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports